import styled from 'styled-components';
import { colors, fontSizes } from '@anyroad/theme';

export const PriceBreakDown = styled.div`
  width: 60%;
  .row {
    &:first-child {
      margin-top: 26px;
    }

    &:last-child {
      margin-bottom: 32px;
    }
  }
`;

export const BreakdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PriceSummaryRow = styled.div`
  color: ${colors.text.secondary};
  font-size: ${fontSizes.small};
`;

export const Unit = styled.div`
  padding-top: 3px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  align-items: start;
`;

export const LeftColumn = styled.div`
  text-align: left;
`;

export const RightColumn = styled.div`
  padding: 0px;
  font-weight: 600;
`;

export const AddonNameText = styled.div`
  font-size: ${fontSizes.medium};
`;

export const AddonLabel = styled.div`
  .addonBreakdown {
    color: ${colors.text.secondary};
    font-size: ${fontSizes.small};
    padding-top: 3px;
  }
`;

export const BookingFeeContainer = styled.div`
  .icon {
    display: inline-block;
    height: ${fontSizes.small};
    margin-left: 4px;
    vertical-align: middle;
    width: ${fontSizes.small};
  }

  .ui.popup {
    width: 200px;
  }
`;

export const ToggleIconContainer = styled.span`
  margin-left: 6px;

  .icon {
    display: inline-block;
    font-size: 8px;
    height: auto;
    margin: 0 2px;
  }
`;
